const $543d94d67409522a$export$edcf47b10d53ec33 = (note)=>note.top_height != null;


export {$543d94d67409522a$export$edcf47b10d53ec33 as hasSpan};
//# sourceMappingURL=column-components.8ae02d44.js.map
